// What the PLG events carry from earlier in the visit: profile views since sign-in, Edge Standard tiles
// clicked, and where a profile was opened from. In localStorage because profiles open in a new tab.

const KEY = "plgAnalytics";

interface ListContext {
  position: number;
  role?: string;
}

interface State {
  views: number;
  tiles: string[];
  opened: Record<string, ListContext>;
}

const EMPTY: State = { views: 0, tiles: [], opened: {} };

function read(): State {
  try {
    const s = JSON.parse(localStorage.getItem(KEY) || "null");
    return s ? { ...EMPTY, ...s } : { ...EMPTY };
  } catch {
    return { ...EMPTY };
  }
}

function write(s: State): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(s));
  } catch {
    // storage unavailable: the counters start again, nothing else breaks
  }
}

/** Counts a profile view and returns the count since sign-in (profile_viewed.session_view_count). */
export function countProfileView(): number {
  const s = read();
  const views = s.views + 1;
  write({ ...s, views });
  return views;
}

export const profileViewCount = () => read().views;

export function rememberStandardTile(tile: string): void {
  const s = read();
  if (!s.tiles.includes(tile)) write({ ...s, tiles: [...s.tiles, tile] });
}

export const standardTilesClicked = () => read().tiles;

/** Set when a card is clicked in the list; the profile (in its own tab) takes it once. */
export function rememberListContext(talentId: string, ctx: ListContext): void {
  const s = read();
  write({ ...s, opened: { ...s.opened, [talentId]: ctx } });
}

export function takeListContext(talentId: string): ListContext | undefined {
  const s = read();
  const ctx = s.opened[talentId];
  if (!ctx) return undefined;
  const { [talentId]: _taken, ...rest } = s.opened;
  write({ ...s, opened: rest });
  return ctx;
}

export function clearPlgAnalyticsSession(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // nothing to clear
  }
}
